var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9688 23.2977V17.5517H13.8428L7.45075 18.3337C7.45075 17.1777 8.50475 16.9397 10.0008 16.5657L15.1008 15.3077C19.1808 14.2877 22.0368 12.2817 22.0368 7.99773C22.0368 3.33973 19.1808 0.177734 11.9728 0.177734C3.94875 0.177734 0.82075 4.35973 0.82075 8.94973V9.45973H7.07675V9.01773C7.07675 6.94373 7.92675 5.99173 11.7348 5.99173C15.2028 5.99173 15.6448 6.73973 15.6448 7.89573C15.6448 8.94973 15.0668 9.39173 13.6048 9.86773L7.41675 11.8397C2.52075 13.4037 0.71875 15.4097 0.71875 19.2857V23.2977H21.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.25d34211dcf92bca39f0237b9e165d62.svg";
export { ForwardRef as ReactComponent };